import Show from 'components/utils/Show';
import {PrintField} from '../vessel/FieldDetail';

const AutoField = ({field, name, ...props}) => {
    if (field) {
        const {
            name: fieldName,
            component: Component,
            initialValue,
            validation,
            shortLabel,
            ...fieldRest
        } = field;

        return (
            <Component name={name || fieldName} {...{...fieldRest, ...props}} />
        );
    } else {
        return null;
    }
};

const LockableAutoField = ({locked, field, name, value}) => {
    return [
        <Show condition={locked} key='print-field'>
            <PrintField name={field.label} value={value} />
        </Show>,
        <AutoField field={field} name={name} hidden={locked} key='autofield' />,
    ];
};

export default AutoField;
export {LockableAutoField};
